import { configureStore } from "@reduxjs/toolkit";
import quotationSlice from "./quotationSlice";
import qoutesSlice from "./qoutesSlice";
import authSlice from "./authSlice";
import leadReducer from './leadSlice';
import commissionReducer from './commissionSlice';
import renewalReducer from './renewalSlice';
import policyReducer from './policySlice';
import debtManagementReducer from './debtManagementSlice';
import portfolioReducer from './portfolioSlice';

export const store = configureStore({
  reducer: {
    quotationSlice,
    qoutesSlice,
    authSlice,
    lead: leadReducer,
    commission: commissionReducer,
    renewal: renewalReducer,
    policy: policyReducer,
    debtManagement: debtManagementReducer,
    portfolio: portfolioReducer,
  },
});

export default store;
